import { Component, Inject, PLATFORM_ID, NgZone } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { PermissionService } from '../../../core/services/permission.service';
import { SettingsService } from '../../../core/services/settings.service';
import { ToastService } from '../../../shared/components/toast/toast.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  username = '';
  password = '';
  showPassword = false;
  isLoading = false;
  companyName = 'Bilali Islamic Shopping';
  private isBrowser: boolean;

  constructor(
    private authService: AuthService,
    private permissionService: PermissionService,
    private router: Router,
    private toastService: ToastService,
    private settingsService: SettingsService,
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.companyName = this.settingsService.getCompanyName();
    
    // Redirect if already logged in (only in browser)
    if (this.isBrowser && this.authService.isAuthenticated()) {
      this.ngZone.run(() => {
        this.router.navigateByUrl(this.permissionService.getDefaultRoute());
      });
    }
  }

  onSubmit(): void {
    console.log('[LoginComponent] onSubmit called');
    console.log('[LoginComponent] Username:', this.username);
    console.log('[LoginComponent] Password length:', this.password?.length);
    console.log('[LoginComponent] isBrowser:', this.isBrowser);
    
    if (!this.username || !this.password) {
      console.warn('[LoginComponent] Missing credentials');
      this.toastService.error('Please enter username and password');
      return;
    }

    console.log('[LoginComponent] Starting login...');
    this.isLoading = true;

    this.authService.login(this.username, this.password).subscribe({
      next: (response) => {
        console.log('[LoginComponent] Login successful:', response);
        this.isLoading = false;
        this.toastService.success('Login successful');
        
        // Use NgZone to ensure router navigation happens in Angular zone
        this.ngZone.run(() => {
          this.router.navigateByUrl(this.permissionService.getDefaultRoute()).then(
            (success) => {
              console.log('[LoginComponent] Navigation success:', success);
              if (!success) {
                console.error('[LoginComponent] Navigation failed');
              }
            },
            (error) => {
              console.error('[LoginComponent] Navigation error:', error);
            }
          );
        });
      },
      error: (error) => {
        console.error('[LoginComponent] Login error:', error);
        this.isLoading = false;
        this.toastService.error(error.message || 'Login failed');
      }
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}




